import React from 'react';
import { Empty } from 'antd';
import cn from 'classnames';
import InnerCard from '../../../../../components/InnerCard/InnerCard';
import useChangeModalVisible from '../../../../../../../hooks/useChangeModalVisible';
import { CardChangeButton } from '../../../../../../../components/Card';
import commonStyles from '../../../AboutRoom.module.scss';
import styles from '../CommonInfoBlock.module.scss';
import EditRoomDescriptionModal from '../../../../../components/modals/EditRoomDescriptionModal/EditRoomDescriptionModal';

const DescriptionCard = ({ room }) => {
  const { visible, showModal, hideModal } = useChangeModalVisible();

  return (
    <InnerCard
      title="Описание"
      action={
        <CardChangeButton
          text={room?.description?.description ? 'Редактировать' : 'Добавить'}
          className={commonStyles.innerCardAction}
          onClick={showModal}
        />
      }
    >
      {room?.description?.description ? (
        <p className={cn(styles.text, styles.description)}>
          {room.description.description}
        </p>
      ) : (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="Нет описания"
        />
      )}
      <EditRoomDescriptionModal
        visible={visible}
        room={room}
        onCancel={hideModal}
      />
    </InnerCard>
  );
};

export default DescriptionCard;
